import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.section<{ gap?: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${props => props.gap || '32px'};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h2`
  ${Typography.M};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const JobCoursesTitle = styled.h2`
  ${Typography.Subhead};
  ${FontWeights.DemiBold};
`

export const LinkButton = styled(Link)`
  color: ${Colors.Blue50};
  ${Typography.Body};
  ${FontWeights.Regular};
`
